export const LOOKUP_WITHOUT_PLATFORM = {
  country: {
    code: 'DE',
  },
  amount: {
    value: '100',
    currency: 'EUR',
  },
};
